//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ColumnsSelect from '@/components/ColumnsSelect'
import LeadsAPI from "@/api/promotores/leads-digitales.api";

export default {
  components: { ColumnsSelect },
  data() {
    return {
      serviciosUrl: process.env.VUE_APP_SERVICIOS_WEB,
      leads: [],
      visible_columns: [
        'solicitud',
        'usuario',
        'calificacion',
        'status',
        'created_at',
      ],
      columns: [
        {
          name: "solicitud",
          label: "Solicitud ID",
          field: "solicitud_id",
          align: "left",
          style: "width: 300px",
          sortable: true,
          required: true,
        },
        {
          name: "usuario",
          label: "Promotor",
          field: "usuario",
          align: "left",
          sortable: true,
          classes: "bg-grey-2 ellipsis",
          style: "width: 300px",
          headerClasses: "bg-primary text-white",
          required: true,
        },
        {
          name: "calificacion",
          label: "Calificación",
          field: "calificacion",
          align: "left",
        },
        {
          name: "status",
          label: "Estado",
          field: "status",
          align: "left",
          sortable: true,
          required: true,
        },
        {
          name: "created_at",
          label: "Creación",
          field: "created_at",
          align: "left",
          sortable: true,
        },
      ],
      loading: false,
      status: [
        { value: "completado", label: "Completado" },
        { value: "en espera", label: "En espera" },
        { value: "procede", label: "Procede" },
        { value: "cancelado", label: "Cancelado" },
        { value: "rollback", label: "Rollback" },
      ],
    };
  },

  mounted() {
    this.loadLeads();
  },

  methods: {
    async loadLeads() {
      try {
        this.loading = true;
        this.leads = await LeadsAPI.all();
      } finally {
        this.loading = false;
      }
    },

    async updateStatus({ _id, status }) {
      this.loading = true;
      await LeadsAPI.update(_id, { status });
      this.loading = false;
    },

    async rating({ _id, calificacion }) {
      this.loading = true;
      await LeadsAPI.update(_id, { calificacion });
      this.loading = false;
    },

  },
};
